export const checkIsCrossCampaignTrackingProperty = (isCrossCampaign) => isCrossCampaign ? '1' : '0';
export const checkIsGetInspiredTrackingProperty = (isGetInspired) => isGetInspired ? '1' : '0';
